import { centerCrop, convertToPercentCrop, convertToPixelCrop } from 'react-image-crop';
import { useEffect, DependencyList } from 'react';

export const TO_RADIANS = Math.PI / 180;

export function useDebounceEffect(fn = () => {}, waitTime, deps = DependencyList) {
    useEffect(() => {
        const t = setTimeout(() => {
            fn.apply(undefined, deps);
        }, waitTime);

        return () => {
            clearTimeout(t);
        };
    }, deps);
}

//Function retrieved from the library and slightly modified to meet our needs.
//In particular the case where we do not have a ratio(aspect)
export function makeAspectCrop(crop, aspect, containerWidth, containerHeight) {
    const pixelCrop = convertToPixelCrop(crop, containerWidth, containerHeight);
    if (!aspect) {
        crop.width = pixelCrop.x + pixelCrop.width > containerWidth ? containerWidth - pixelCrop.x : crop.width;
        crop.height = pixelCrop.y + pixelCrop.height > containerHeight ? containerHeight - pixelCrop.y : crop.height;

        return crop;
    }

    if (crop.width) {
        pixelCrop.height = pixelCrop.width / aspect;
    }

    if (crop.height) {
        pixelCrop.width = pixelCrop.height * aspect;
    }

    if (pixelCrop.y + pixelCrop.height > containerHeight) {
        pixelCrop.height = containerHeight - pixelCrop.y;
        pixelCrop.width = pixelCrop.height * aspect;
    }

    if (pixelCrop.x + pixelCrop.width > containerWidth) {
        pixelCrop.width = containerWidth - pixelCrop.x;
        pixelCrop.height = pixelCrop.width / aspect;
    }

    if (crop.unit === '%') {
        return convertToPercentCrop(pixelCrop, containerWidth, containerHeight);
    }

    return pixelCrop;
}

//allows to generate a File object from a url or blobUrl
export async function dataUrlToFileUsingFetch(url, fileName, mimeType) {
    const response = await fetch(url);
    const buffer = await response.arrayBuffer();

    return new File([buffer], fileName, { type: mimeType });
}

// allows to position the crop when loading the image, taking into account the ratio(aspect)
export function centerAspectCrop(mediaWidth, mediaHeight, aspect) {
    let _crop = { unit: 'px', width: mediaWidth };
    if (!aspect) {
        _crop = { unit: 'px', width: mediaWidth, height: mediaHeight };
    }
    return centerCrop(makeAspectCrop(_crop, aspect, mediaWidth, mediaHeight), mediaWidth, mediaHeight);
}
